import { createStyles } from '@mantine/core';
var useStyles = createStyles(function () {
  return {
    systemName: {
      filter: "drop-shadow(0px 0px 0.05em #000) drop-shadow(0px 0px 5px #000)",
      fill: "#FFFFFF",
      fontSize: 100,
      dominantBaseline: "middle"
    },
    externalSystemName: {
      filter: "drop-shadow(0px 0px 0.05em #000) drop-shadow(0px 0px 5px #000)",
      fill: "#FFFFFF",
      fontSize: 80,
      dominantBaseline: "middle"
    }
  };
});
export { useStyles as default };